/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Border_ColorInputs */

const fr_label_border_color = /** @type {(inputs: Label_Border_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur de bordure`)
};

const en_label_border_color = /** @type {(inputs: Label_Border_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Border color`)
};

/**
* | output |
* | --- |
* | "Border color" |
*
* @param {Label_Border_ColorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_border_color = /** @type {((inputs?: Label_Border_ColorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Border_ColorInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_border_color(inputs)
	return en_label_border_color(inputs)
});